import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React from "react";
import { CInput, CTextarea } from "../common";
import { useFormik } from "formik";
import { ManualVideoModel } from "../../services";
import { manualVideoSchema } from "../../utils/schemas";

export default function AddManualVideoModal({ fetchVideos }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const onAddVideo = async (values) => {
    try {
      await ManualVideoModel.create(values);
      formik.resetForm();
      onClose();
      fetchVideos();
      toast({
        description: "Video added successfully!",
        status: "success",
        isClosable: true,
      });
    } catch (error) {
      toast({
        description: "Something went wrong!",
        status: "error",
        isClosable: true,
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      title: "",
      url: "",
      description: "",
    },
    validationSchema: manualVideoSchema,
    onSubmit: onAddVideo,
  });

  return (
    <>
      <Button
        bgColor="black"
        borderRadius="lg"
        fontWeight="medium"
        py="6"
        my="2"
        onClick={onOpen}
      >
        Add New
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add New Video</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box mb={3}>
              <CInput
                label="Title"
                name="title"
                placeholder="Enter Video Title"
                value={formik.values.title}
                onChange={formik.handleChange}
                touched={formik.touched.title}
                errors={formik.errors.title}
              />
            </Box>
            <Box mb={3}>
              <CInput
                label="URL"
                name="url"
                placeholder="Enter Video URL"
                value={formik.values.url}
                onChange={formik.handleChange}
                touched={formik.touched.url}
                errors={formik.errors.url}
              />
            </Box>
            <CTextarea
              label="Description (optional)"
              name="description"
              placeholder="Enter Description"
              value={formik.values.description}
              onChange={formik.handleChange}
              touched={formik.touched.description}
              errors={formik.errors.description}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              bgColor="gray.200"
              color="black"
              borderRadius="lg"
              fontWeight="medium"
              py="6"
              me={3}
              onClick={onClose}
              isDisabled={formik.isSubmitting}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              bgColor="black"
              borderRadius="lg"
              fontWeight="medium"
              py="6"
              onClick={formik.handleSubmit}
              isLoading={formik.isSubmitting}
              loadingText="Submitting"
            >
              Submit
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
